enum BankCardType {
  Any,
  Russian,
  International
}

export default BankCardType
